import { render, staticRenderFns } from "./OrderSizeTableAdmin.vue?vue&type=template&id=6db935e0&scoped=true"
import script from "./OrderSizeTableAdmin.vue?vue&type=script&lang=js"
export * from "./OrderSizeTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db935e0",
  null
  
)

export default component.exports